import { empty } from "../../constants/placeholders"

export const budgetFormat = (
  budget: number | string | null,
  { currency = "USD", ...options }: Intl.NumberFormatOptions = {}
): string => {
  if (budget === null || budget === "") return empty

  const numericValue = typeof budget === "string" ? parseFloat(budget) : budget

  if (isNaN(numericValue)) return empty

  return new Intl.NumberFormat("en-US", {
    maximumFractionDigits: 2,
    minimumFractionDigits: 0,
    notation: "standard",
    compactDisplay: "short",
    ...(currency ? { currency, style: "currency" } : {}),
    ...options
  }).format(numericValue)
}

/**
 * A money figure in accounting style: a negative amount reads as
 * "($611,969)" rather than "-$611,969", which is how an overrun is shown on
 * the financial snapshot cards.
 */
export const accountingFormat = (
  value: number | string | null,
  options: Intl.NumberFormatOptions = {}
): string => budgetFormat(value, { currencySign: "accounting", ...options })
